<template>
    <article>
        <v-input-field
            label="Title"
            description="The title for the note."
            v-model="note.title"
            placeholder="Enter Title"
            :readonly="readonly"
            :error="error('title')"
            :state="errorState('title')"/>

        <v-input-field
            label="Subtitle"
            description="The subtitle for the note."
            v-model="note.subtitle"
            placeholder="Enter Subtitle"
            :readonly="readonly"
            :error="error('subtitle')"
            :state="errorState('subtitle')"/>

        <v-rich-text-field
            label="Content"
            description="The Content for the Note"
            v-model="note.content"
            placeholder="Enter Content"
            :readonly="readonly"
            :error="error('content')"
            :state="errorState('content')"/>

        <image-upload-field
            label="Image"
            description="The image for the note."
            v-model="note.image_url"
            :readonly="readonly"
            :error="error('image_url')"
            :state="errorState('image_url')"/>
    </article>
</template>

<script>
    import BaseType from "./Base"
    import ImageUploadField from "../../../Fields/ImageUploadField.vue"

    export default {
        extends: BaseType,
        components: {ImageUploadField},
        data()
        {
            return {
                defaults: {
                    title: null,
                    subtitle: null,
                    content: null,
                    image_url: null
                },
                rules: {
                    image_url: "required|string"
                }
            }
        }
    }
</script>